export default __webpack_public_path__ + "static/media/icon-non-ricordo.3c597b1d.svg";